// extracted by mini-css-extract-plugin
export default {"TabsVertical":"TabsVertical_TabsVertical__vskNN","Tab":"TabsVertical_Tab__Qt-eU","Tab__active":"TabsVertical_Tab__active__mq9va"};